define('modules/ads/ad_model',[
  'backbone',
  '_',
  'session'
], function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    url: function () {
      return session.get('apiUrl') + 'htmladlocation/' + this.get('id');
    }
  });

  return Model;
});

